import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { format } from "date-fns";
import { Button } from "@mui/material";
import TitleSupportDashboard from "../Misc/TitleSupportDashboard";
import ClientRowSupportDashboard from "../Misc/ClientRowSupportDashboard";
import DateTodayLarge from "../DateTodayLarge";
import { useNavigate } from "react-router-dom";

function AllClientAvailability(props) {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [clientDisplayLimit, setClientDisplayLimit] = useState(10);
  const [, setTotalRecords] = useState(0);
  const [filteredClients] = useState([]);
  const [clientsIncoming, setClientsIncoming] = useState([]);
  const [isLoadingIncoming, setIsLoadingIncoming] = useState(true);
  const [, setTotalRecordsIncoming] = useState(0);

  const [filters, setFilters] = useState({
    fullName: "",
    primaryAddiction: "",
    estimatedArrivalDate: "",
    admissionDate: "",
    durationOfStay: "",
    flights: "",
    payment: "",
    passport: "",
    vipTransfer: "",
  });

  useEffect(() => {
    setIsLoading(true);

    const queryRef = query(
      collection(db, "clients"),
      where("clientStatus", "==", "In House")
    );

    const unsubscribe = onSnapshot(
      queryRef,
      async (snapshot) => {
        const clientPromises = snapshot.docs.map(async (docList) => {
          let clientData = docList.data();
          clientData.id = docList.id;

          // Asynchronously fetch alerts data
          const alertsQueryRef = collection(
            db,
            "clients",
            clientData.id,
            "alerts"
          );
          const alertsSnapshot = await getDocs(alertsQueryRef);
          let alerts = [];
          alertsSnapshot.forEach((alertDoc) => {
            alerts.push(alertDoc.data());
          });

          if (alerts.length > 0) {
            clientData.alerts = alerts;
          }

          return clientData;
        });

        // Wait for all clients and their dependent data to be fetched
        const clients = await Promise.all(clientPromises);
        setClients(clients);
        setTotalRecords(clients.length);
        setIsLoading(false);
      },
      (error) => {
        console.error("Failed to fetch In House clients:", error);
        setIsLoading(false);
      }
    );

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  useEffect(() => {
    setIsLoadingIncoming(true);

    const clientQuery = query(
      collection(db, "clients"),
      where("clientStatus", "==", "Incoming")
    );

    const unsubscribe = onSnapshot(
      clientQuery,
      async (snapshot) => {
        const clientPromises = snapshot.docs.map(async (docList) => {
          const clientData = docList.data();
          clientData.id = docList.id;

          // Asynchronously fetch pre-admission assessments
          const assessmentDocRef = doc(
            db,
            "preAdmissionAssessments",
            clientData.id
          );
          const assessmentSnapshot = await getDoc(assessmentDocRef);
          if (assessmentSnapshot.exists()) {
            const assessmentData = assessmentSnapshot.data();
            return { ...clientData, ...assessmentData }; // merge assessment data into clientData
          } else {
            return clientData;
          }
        });

        // Wait for all clients and their dependent data to be fetched
        const clientsIncoming = await Promise.all(clientPromises);
        setClientsIncoming(clientsIncoming);
        setTotalRecordsIncoming(clientsIncoming.length);
        setIsLoadingIncoming(false);
      },
      (error) => {
        console.error("Failed to fetch Incoming clients:", error);
        setIsLoadingIncoming(false);
      }
    );

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy");
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "20px",
          paddingLeft: "0px",
        }}
      ></div>

      <div
        style={{
          paddingLeft: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{
              backgroundColor: "#1e293b",
              fontSize: "20px",
              textAlign: "center",
              color: "white",
              width: "200px",
              marginBottom: "10px",
            }}
          >
            <DateTodayLarge />
          </div>
          <div
            style={{
              fontSize: "20px",
              textAlign: "center",
              marginLeft: "10px",
              color: "white",
              width: "200px",
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Button variant="outlined" onClick={handleClick}>
              BACK TO HOME
            </Button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingBottom: "20px",
            overflowX: "auto",
            justifyContent: "center",
            alignContent: "flex-end",
            alignItems: "flex-end",
            borderBottom: "3px solid lightgray",
            width: "auto",
            paddingLeft: "10px",
            marginTop: "20px",
          }}
        >
          <TitleSupportDashboard
            width="60px"
            title="COUNT"
            value={filters.fullName}
            onChange={(e) =>
              setFilters({ ...filters, fullName: e.target.value })
            }
          />
          {/* </div> */}

          <TitleSupportDashboard
            width="120px"
            title="STATUS"
            value={filters.status}
            onChange={(e) =>
              setFilters({ ...filters, primaryAddiction: e.target.value })
            }
          />
          <TitleSupportDashboard
            width="120px"
            title="NAME"
            value={filters.estimatedArrivalDate}
            onChange={(e) =>
              setFilters({ ...filters, estimatedArrivalDate: e.target.value })
            }
          />
          <TitleSupportDashboard
            width="80px"
            title="ROOM #"
            value={filters.admissionDate}
            onChange={(e) =>
              setFilters({ ...filters, admissionDate: e.target.value })
            }
          />
          <TitleSupportDashboard
            width="100px"
            title="THERAPIST"
            value={filters.durationOfStay}
            onChange={(e) =>
              setFilters({ ...filters, durationOfStay: e.target.value })
            }
          />

          <TitleSupportDashboard width="160px" title="THERAPIST APPT" />
          <TitleSupportDashboard width="90px" title="MASSAGE" />
          <TitleSupportDashboard
            width="160px"
            title="SUPPORT WORKER"
            value={filters.flights}
            onChange={(e) =>
              setFilters({ ...filters, flights: e.target.value })
            }
          />

          <TitleSupportDashboard width="180px" title="SUPPORT W. Appt" />
          <TitleSupportDashboard width="160px" title="12 Steps Appt" />

          <TitleSupportDashboard width="120px" title="Medical Appt" />
          <TitleSupportDashboard width="120px" title="Visa Appt" />

          <TitleSupportDashboard width="120px" title="ADMISSION DATE" />
          <TitleSupportDashboard width="120px" title="SWOT DATE" />
          <TitleSupportDashboard width="120px" title="PROJECTED DC" />
          <TitleSupportDashboard width="120px" title="LENGTH OF STAY" />
        </div>
      </div>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "500px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <div
          className="client-widgets-global-container"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            paddingTop: "5px",
            marginBottom: "20px",
            paddingLeft: "10px",
          }}
        >
          {/* {clients.slice(0, clientDisplayLimit).map((client, index) => ( */}
          {clients.map((client, index) => (
            <ClientRowSupportDashboard
              key={client.id}
              count={index + 1}
              clientStatus={client.clientStatus}
              firstName={client.firstName}
              lastName={client.lastName}
              gender={client.gender}
              email={client.email}
              eta={formatDate(client.eta)}
              admissionDate={formatDate(client.dateOfAdmission)}
              nationality={client.nationality}
              country={client.country}
              primaryAddiction={client.primaryAddiction}
              secondaryAddiction={client.secondaryAddiction}
              inActiveRecovery={client.recoveryRadio ? "Yes" : "No"}
              googleReviewDone={client.googleReview ? "Yes" : "No"}
              personalEmail={client.personalEmail}
              durationOfStay={client.durationOfStay}
              flight={client.flightDetails}
              vipTransfer={client.vipTransfer}
              passportStatus={client.passportStatus}
              paymentDetail={client.paymentDetails}
              profilPicture={client.profilePicture}
              idClient={client.id}
              clientData={client}
              swotDate={formatDate(client.swot)}
              roomNumber={client.roomNumber}
              supportWorker={client.assignedSupportWorker}
              therapistName={client.selectedTherapist}
              alerts={client.alerts}
              projectedDischarge={formatDate(
                client.projectedResidentialDischargeDate
              )}
            />
          ))}
        </div>
      )}

      {isLoadingIncoming ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "500px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <div
          className="client-widgets-global-container"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            paddingTop: "5px",
            marginBottom: "20px",
            paddingLeft: "10px",
          }}
        >
          {clientsIncoming.slice(0, clientDisplayLimit).map((client, index) => (
            <ClientRowSupportDashboard
              key={client.id}
              count={index + 1}
              clientStatus={client.clientStatus}
              firstName={client.firstName}
              lastName={client.lastName}
              gender={client.gender}
              email={client.email}
              eta={formatDate(client.eta)}
              admissionDate={formatDate(client.dateOfAdmission)}
              nationality={client.nationality}
              country={client.country}
              primaryAddiction={client.primaryAddiction}
              secondaryAddiction={client.secondaryAddiction}
              inActiveRecovery={client.recoveryRadio ? "Yes" : "No"}
              googleReviewDone={client.googleReview ? "Yes" : "No"}
              personalEmail={client.personalEmail}
              durationOfStay={client.durationOfStay}
              flight={client.flightDetails}
              vipTransfer={client.vipTransfer}
              passportStatus={client.passportStatus}
              paymentDetail={client.paymentDetails}
              profilPicture={client.profilePicture}
              idClient={client.id}
              clientData={client}
              swotDate={formatDate(client.swot)}
              roomNumber={client.roomNumber}
              supportWorker={client.assignedSupportWorker}
              therapistName={client.selectedTherapist}
              alerts={client.alerts}
              projectedDischarge={formatDate(
                client.projectedResidentialDischargeDate
              )}
            />
          ))}
        </div>
      )}

      {!isLoading && filteredClients.length > clientDisplayLimit && (
        <div className="seemore-container">
          <Button
            onClick={() => setClientDisplayLimit(clientDisplayLimit + 10)}
          >
            See more
          </Button>
        </div>
      )}

      {/* <div
        style={{
          width: "2200px",
          height: "150px",
          marginLeft: "22px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
          paddingLeft: "20%",
          paddingRight: "20%",
        }}
      >
        <MetricsWidget
          title="Total In-House Clients"
          value={clients.length.toString()}
          title2="Clients"
        />
       
        <MetricsWidget
          title="Next Discharge"
          value={
            nextDischargeClient
              ? `${nextDischargeClient.firstName} ${nextDischargeClient.lastName}`
              : "No upcoming discharges"
          }
          title2={
            nextDischargeClient
              ? formatDate2(
                  new Date(
                    nextDischargeClient.projectedResidentialDischargeDate
                      ?.seconds * 1000
                  )
                )
              : "h"
          }
        />

       
      </div> */}
    </div>
  );
}

export default AllClientAvailability;
